import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { COMPANY } from "../../content/site";

export const EmergencyBar = () => (
  <div
    data-testid="emergency-bar"
    role="region"
    aria-label="24/7 emergency contact"
    className="border-b border-alert/30 bg-[#030f1b]"
  >
    <div className="container-x flex h-11 items-center justify-between gap-2 sm:gap-3">
      <p data-testid="status-indicator" className="flex min-w-0 items-center gap-2 font-mono text-paper">
        <span className="pulse-dot inline-block h-2 w-2 shrink-0 rounded-full bg-gold text-gold" aria-hidden="true" />
        <span className="hidden text-[10.5px] uppercase tracking-[0.16em] md:inline">24/7 · Call handlers available now</span>
        <span className="flex flex-col text-[9.5px] uppercase leading-[1.15] tracking-[0.08em] md:hidden">
          <span>24/7 ·</span><span className="whitespace-nowrap">Available now</span>
        </span>
      </p>
      <div className="flex shrink-0 items-center gap-2.5 sm:gap-5">
        <a
          href={COMPANY.hotlineTel}
          data-testid="emergency-hotline-link"
          aria-label={`Call the 24/7 emergency hotline on ${COMPANY.hotline}`}
          className="flex items-center gap-1.5 whitespace-nowrap font-mono text-[13px] sm:text-[15px] font-semibold text-gold hover:text-[#ffe09a] transition-colors"
        >
          <Phone className="hidden h-3.5 w-3.5 sm:block" aria-hidden="true" />
          {COMPANY.hotline}
        </a>
        <Link
          to="/report"
          data-testid="emergency-report-button"
          className="rounded-full bg-alert-strong px-3 py-1.5 text-[12px] sm:px-4 sm:text-[13px] font-semibold text-white transition-colors hover:bg-[#b8233a] whitespace-nowrap"
        >
          Report an Issue
        </Link>
      </div>
    </div>
  </div>
);
